import { COUNTRY_CODES } from '@spa/shared/constants/countryCodes';

export const getCountryCode = cityCode => cityCode?.split('-')[0].toLowerCase();

export const getCountryNamefromCityCode = cityCode =>
  COUNTRY_CODES.find(({ code }) => code === getCountryCode(cityCode).toUpperCase())?.name.toLowerCase();
